import glam from 'glamorous';
import React from 'react';
import { ContentSubTitle } from 'module/Model/Content';
import { createPureComponent } from 'module/Common';
import { LocalizedContent, Wave, BrandonGrotesque } from 'module/View/Common';

const Wrapper = glam.div({
  pointerEvents: 'all',
});

export const TitleWrapper = glam.h3({
  fontSize: '3rem',
  fontFamily: BrandonGrotesque.regular,
  fontStyle: 'normal',
  fontWeight: 'normal',
});

type Props = {
  item: ContentSubTitle;
  itemIndex: number;
};

export const SubTitle = createPureComponent<Props>('SubTitle', ({ item, itemIndex }) => {
  return (
    <Wrapper>
      <LocalizedContent content={ContentSubTitle.getTitle(item)}>
        {value => <TitleWrapper>{value}</TitleWrapper>}
      </LocalizedContent>
      {ContentSubTitle.hasWave(item) ? <Wave width={300} /> : null}
    </Wrapper>
  );
});



// WEBPACK FOOTER //
// ./src/module/View/Content/component/ContentItems/items/SubTitle.tsx